import React, { useState, useEffect, useRef } from "react";
import styled from "@emotion/styled";

const GradientIndicator = ({
  children,
  primaryColor = "#fafafa",
  fadeColor = "transparent",
  fadeHeight = "90px",
}) => {
  const scrollableRef = useRef(null);
  const [overlayClasses, setOverlayClasses] = useState(["top"]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollableScrollTop = scrollableRef.current.scrollTop;
      const atTop = scrollableScrollTop === 0;
      const atBottom =
        scrollableScrollTop + scrollableRef.current.clientHeight >=
        scrollableRef.current.scrollHeight - 5;

      const newOverlayClasses = [];

      if (atBottom) {
        newOverlayClasses.push("bottom");
      }
      if (atTop) {
        newOverlayClasses.push("top");
      }

      setOverlayClasses(newOverlayClasses);
    };

    scrollableRef.current.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      scrollableRef.current.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <ScrollWrapper
      className={overlayClasses.join(" ")}
      primaryColor={primaryColor}
      fadeColor={fadeColor}
      fadeHeight={fadeHeight}
    >
      <Scrollable ref={scrollableRef}>
        <Content>{children}</Content>
      </Scrollable>
    </ScrollWrapper>
  );
};

const ScrollWrapper = styled.div`
  width: 100%;

  &:before,
  &:after {
    content: "";
    width: 320px;
    height: ${(props) => props.fadeHeight};
    position: absolute;
  }

  &:before {
    background: linear-gradient(${(props) => props.primaryColor}, transparent);
  }

  &:after {
    margin-top: -90px;
    background: linear-gradient(transparent, ${(props) => props.primaryColor});
  }

  &.top:before {
    display: none;
  }

  &.bottom:after {
    display: none;
  }
`;

const Scrollable = styled.div`
  width: 333px;
  max-height: 530px;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 5px !important;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px !important;
    background: #cfd1d1 !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--color-primary-purple) !important;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: darkgray #cfd1d1;

  /* Microsoft Edge */
  &::-ms-scrollbar {
    width: 5px !important;
  }

  &::-ms-scrollbar-thumb {
    border-radius: 5px !important;
    background: #cfd1d1 !important;
  }

  &::-ms-scrollbar-thumb:hover {
    background: var(--color-primary-purple) !important;
  }
`;

const Content = styled.div`
  width: 100%;
  padding-right: 8px;
`;

export default GradientIndicator;
